<template>
  <div v-if="this.$store.getters.Yetki.IcraTahsilat>0">
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-form class="BilgiForm" :rules="FormHata" :model="Form"
             @submit.prevent.native="FormKaydet"
             ref="Form">
      <h2>İcra Tahsilatı <a @click="$emit('Modal', false)" class="ModalKapat"><i class="el-icon-close"></i></a>
      </h2>
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="Tutar" prop="Tutar">
            <el-input type="input" v-model="Form.Tutar">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Kasa" prop="Kasa_id">
            <el-cascader
              collapse-tags
              placeholder="Kasa Seçiniz"
              :props="{ multiple: false}"
              :options="Kasalar"
              v-model="Form.Kasa_id"
              filterable></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Ödeme Tarihi" prop="Tarih">
            <el-date-picker
              v-model="Form.Tarih"
              type="date"
              placeholder=""
              format="dd.MM.yyyy">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <button v-if="!lo" type="button" @click="FormKaydet"
                  class="el-button mt-2 YeniBtn el-button--success el-button--mini btn-block">ÖDEME AL VE MAKBUZ ÜRET
          </button>
        </el-col>
      </el-row>
    </el-form>
    <MakbuzDetay v-if="MakbuzDetayModal" :mNo="mNo" @MakbuzDetayModal="MakbuzDetayModal=false"
                 :MakbuzDetayModal="MakbuzDetayModal"></MakbuzDetay>
  </div>
</template>

<script>
  import Yukleniyor from "../../Doc/Yukleniyor";
  import MakbuzDetay from "../Vezne/MakbuzDetay";

  export default {
    components: {MakbuzDetay, Yukleniyor},
    props: ['data', 'Bina_id'],
    data() {
      return {
        lo: false,
        MakbuzDetayModal: false,
        mNo: null,
        Kasalar: [],
        Form: {
          Kasa_id: null,
          Tutar: null,
          Tarih: null,
          Icra_id: null
        },
        FormHata: {
          Kasa_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Tutar: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Tarih: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        }
      }
    },
    methods: {
      FormKaydet() {
        this.$refs['Form'].validate((valid) => {
          if (valid) {
            this.lo = true;
            this.Form.Icra_id = this.data.id;
            this.$store.dispatch("Post", {...this.Form, path: 'icra/odeme/'})
              .then(response => {
                this.lo = false;
                if (response.Durum == "OK") {
                  this.mNo = response.mNo;
                  this.MakbuzDetayModal = true;
                  this.Yenile = true;
                  this.$message.success("Ödeme alındı");
                } else {
                  this.$message.error(response.Mesaj);
                  this.hata = response.Hata;
                }
              })
          }
        })
      }
    },
    created() {
      this.Tarih = new Date();
      this.$store.dispatch("Get", {path: 'muhasebe/kasa/' + this.Bina_id})
        .then(response => {
          this.lo = false;
          if (response.Durum === 'OK') {
            this.Kasalar = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Icra/IcraOdemeAl.vue